import React from "react";
import styled from 'styled-components'

const DesktopStoriesContainer = styled.div.attrs({
	className: "flex flex-col items-center justify-center w-full mt-5"
})``;

export default DesktopStoriesContainer;